// The cookies that mean "this browser has already given us an email".
//
// THE ARTICLE WALL NO LONGER TAKES AN EMAIL, AND NO COOKIE HERE OPENS IT. The
// library charges: ten articles a calendar month, then the subscription or the
// community membership, and an address buys nothing. `POST /api/articles/unlock`
// was the route that traded an email for unlimited reading and it is gone, so
// nothing sets ARTICLES_UNLOCK_COOKIE any more and no gate reads it. Do not
// wire another one; an email-for-access path is the pay ruling reversed.
//
// What survives is the SHARED "we already have this address" signal, which is
// about not re-nagging someone rather than about access: the intro popup
// matches its own cookie exactly, and the newsletter signup sets a sibling in
// the same set. Those are the only two live setters; the three names in that
// set with none are explained at SHARED_EMAIL_COOKIES below.
//
// Deliberately plain — no "use client", no "server-only" — so both sides can
// import it.

/** Legacy. Set by the retired email-unlock route; retained only so the
 *  shared already-have-the-address set below stays complete for the popups
 *  that read it. It grants no reading access. */
export const ARTICLES_UNLOCK_COOKIE = "ca_articles_unlocked"

/**
 * The shared captured-email cookie the intro popup also reads. Marking it here
 * stops the popup on another page re-nagging someone who just handed over his
 * address at the wall.
 */
export const INTRO_CAPTURED_COOKIE = "ca_intro_captured"

/** The intro popup matches the whole cookie string EXACTLY
 * (`part === "ca_intro_captured=true"`), so this value is part of its contract. */
export const INTRO_CAPTURED_VALUE = "true"

/**
 * Anyone who already gave us their email ANYWHERE is captured. Re-asking a
 * subscriber for the address he already handed over reads as broken, so the
 * intro popup treats any name here as "already have it". Two have a live
 * setter: the newsletter signup writes `ca_newsletter_status`
 * (`app/api/newsletter/route.ts`) and the intro popup writes its own
 * INTRO_CAPTURED_COOKIE. The other three (the retired article unlock, the
 * free-training gate and the free community join) are set by nothing any
 * more; they stay listed so a browser that still carries one is never
 * re-asked.
 */
export const SHARED_EMAIL_COOKIES = [
  ARTICLES_UNLOCK_COOKIE,
  "ca_newsletter_status",
  INTRO_CAPTURED_COOKIE,
  "ca_free_training",
  "ca_community_joined",
] as const

export const UNLOCK_COOKIE_MAX_AGE = 60 * 60 * 24 * 365
